import { Component, Input } from "@angular/core";

@Component({
  selector: "app-radio-button",
  templateUrl: "./radio-button.component.html",
})
export class RadioButtonComponent {
  @Input() isSelected: boolean;
  @Input() style: "default" | "hud" = "default";
}
